import { Component, OnInit, Input } from '@angular/core';
import { IDataScope } from 'src/app/modules/auth/models/IDataScope';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mobile-location-picker',
    templateUrl: './mobile-location-picker.component.html',
    styleUrls: ['./mobile-location-picker.component.scss'],
    standalone: false
})
export class MobileLocationPickerComponent implements OnInit {
  @Input() locations: (IDataScope & { unique: boolean })[];
  @Input() selectedLocationId: number | null;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onLocationSelect(locationId: number | 'account') {
    if (locationId === 'account') {
      this.router.navigate(['/user', 'profile']);
    } else {
      const baseUrlParts = this.router.url.split('?');
      const urlParts = baseUrlParts[0].split('/');
      urlParts[2] = String(locationId);
      this.router.navigateByUrl([urlParts.join('/'), ...baseUrlParts.slice(1)].join('?'));
    }
  }
}
